import React, { useState, useRef, useEffect, useCallback } from "react";
import SideBar from "../../Reusable/SideBar/SideBar.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import AnimationContainer from "../../Reusable/AnimationContainer/AnimationContainer.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import isTouch from "../../../utils/checkTouchDevice.js";
import { useLightBox } from "../../../contexts/lightBoxContext/lightBoxContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import usePagination from "../../../hooks/usePagination.js";
import { useCloseLightBox } from "../../../hooks/useCloseLightBox.js";

import "./LightBoxManager.scss";

const LightBoxContent = ({ children }) => {
  const { setLightBox, getFileId, getFileData } = useLightBox();
  const { getFilesData, getFilesList } = useMail();
  const { desktopCondition } = useMediaQueries();

  //ANIMATION SECTION
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setTimeout(() => setMounted(true), 1);
    // setMounted(true);
    return () => setMounted(false);
  }, [getFileId()]);

  //CHANGE ITEM SECTION
  const currentIndex = getFilesList().indexOf(getFileId());

  const { triggerFunction } = usePagination();

  const containerRef = useRef();

  useEffect(() => {
    if (currentIndex + 10 > getFilesList().length) {
      triggerFunction(true);
    }
  }, [currentIndex]);

  const goPrevItem = () => {
    if (currentIndex === 0 || getFilesList().length === 0) {
      return null;
    } else {
      const prevId = !getFilesList()[currentIndex - 1].folder
        ? getFilesList()[currentIndex - 1]
        : getFilesList()[currentIndex - 2];

      if (!prevId) {
        return null;
      }
      const fileType = getFilesData()[prevId].Type;
      setLightBox(fileType, prevId);
    }
  };

  const goNextItem = () => {
    if (
      currentIndex === getFilesList().length - 1 ||
      getFilesList().length === 0
    ) {
      return null;
    } else {
      const nextId = !getFilesList()[currentIndex + 1].folder
        ? getFilesList()[currentIndex + 1]
        : getFilesList()[currentIndex + 2];

      if (!nextId) {
        return null;
      }
      const fileType = getFilesData()[nextId].Type;
      setLightBox(fileType, nextId);
    }
  };

  //TOUCH SECTION
  const [touchStartPosition, setTouchStartPosition] = useState(null);
  const [touchEndPosition, setTouchEndPosition] = useState(null);

  const handleTouchMove = (e) => {
    if (e.touches.length < 2) {
      for (let i = 0; i < containerRef.current.children.length; i++) {
        const item = containerRef.current.children[i];
        if (item.classList.contains("item-in-view")) {
          item.style.transform = `translateX(${
            (e.touches[0].clientX - touchStartPosition) / 3 + "px"
          })`;
        }
      }
      setTouchEndPosition(e.touches[0].clientX);
      //   if (e.touches[0].clientX - touchStartPosition > window.innerWidth / 3) {
      //     containerRef.current.firstElementChild.style.transform = "scale(0.8)";
      //   } else if (
      //     e.touches[0].clientX - touchStartPosition <
      //     -window.innerWidth / 3
      //   ) {
      //     containerRef.current.firstElementChild.style.transform = "scale(0.8)";
      //   } else {
      //     containerRef.current.firstElementChild.style.transform = "scale(1)";
      //   }
    }
  };

  const handleTouchEnd = (e) => {
    if (touchEndPosition && touchStartPosition) {
      if (touchEndPosition - touchStartPosition > window.innerWidth / 3) {
        goPrevItem();
      } else if (
        touchEndPosition - touchStartPosition <
        -window.innerWidth / 3
      ) {
        goNextItem();
      }
    }
    // containerRef.current.firstElementChild.style.marginInlineStart = 0;
    // containerRef.current.firstElementChild.style.transform = "scale(1)";
    for (let i = 0; i < containerRef.current.children.length; i++) {
      const item = containerRef.current.children[i];
      if (item.classList.contains("item-in-view")) {
        item.style.transform = `translateX(0)`;
      }
    }
    setTouchStartPosition(null);
    setTouchEndPosition(null);
  };

  //KEYBOARD ACTIONS
  //INBOX+MAILDATA
  const closeLightBox = useCloseLightBox();

  const KeyboardPressHandler = (e) => {
    e.keyCode === 27 && closeLightBox();
    e.keyCode === 39 && goNextItem();
    e.keyCode === 37 && goPrevItem();
  };

  useEffect(() => {
    if (!getFileData()) {
      document.addEventListener("keydown", KeyboardPressHandler);
    }
    return () => {
      document.removeEventListener("keydown", KeyboardPressHandler);
    };
  }, [getFileId(), getFilesList()]);

  const coditionToShowArrows =
    currentIndex >= 0 && (!isTouch() || desktopCondition) && !getFileData();

  return (
    <AnimationContainer
      animationOn={mounted || true} // here should be {mounter || desctopcondition} and add anther fade effect on mobile view
      animationClassName={"fade-in-lightbox"}
    >
      <div className="lightBox-content row">
        {coditionToShowArrows ? (
          <div className="lightbox-arrow prev" onClick={goPrevItem}>
            <Tooltip
              id={"previousFileIcon"}
              tooltipTextKey="prevfile-icon-tooltip-text"
              top
            >
              <Icon
                name="arrow-left"
                className={currentIndex === 0 ? "disabled" : null}
              />
            </Tooltip>
          </div>
        ) : null}
        <div
          className="col-12 view-container"
          onTouchStart={(e) =>
            !getFileData() && setTouchStartPosition(e.touches[0].clientX)
          }
          onTouchMove={(e) => !getFileData() && handleTouchMove(e)}
          onTouchEnd={(e) => !getFileData() && handleTouchEnd(e)}
          ref={containerRef}
        >
          {children}
        </div>
        {coditionToShowArrows ? (
          <div className="lightbox-arrow next" onClick={goNextItem}>
            <Tooltip
              id={"nextFileIcon"}
              tooltipTextKey="nextfile-icon-tooltip-text"
              top
            >
              <Icon
                name="arrow-right"
                className={
                  currentIndex === getFilesList().length - 1 ? "disabled" : null
                }
              />
            </Tooltip>
          </div>
        ) : null}
        <SideBar lightBoxView={true} />
      </div>
    </AnimationContainer>
  );
};

export default LightBoxContent;
